import { CrmExperienceOption } from 'signup-constants/signupData/CrmExperienceOption';
import { Flow } from 'signup-constants/Flow';
import { isFlow } from '../../utils/isFlow';
import { Step } from '../../views/Step';
import { Data } from '../../signup-data/DATA';
import { getSignupDataValue } from '../../store/signup-data/selectors';
import { getIsMobile } from '../../utils/deviceUtils';
import { FlowStateManager } from '../../flow-management/FlowStateManager';

const getIsNotMobile = () => !getIsMobile();

const getIsCrmFlow = () => isFlow(Flow.Crm);

const getHasSubmittedNoCrmExperience = state => {
  const hasSubmittedNoCrmExperience = getSignupDataValue(state, Data.CrmExperienceLevel) === CrmExperienceOption.None;
  return hasSubmittedNoCrmExperience;
};

export const BranchFreeCRMTour = {
  name: 'BranchFreeCRMTour',
  stateCheck: state => getIsNotMobile() && getIsCrmFlow() && getHasSubmittedNoCrmExperience(state),
  rebuildFlow: (flow, state, dispatch) => {
    return dispatch(FlowStateManager.pushNextSteps(Step.FreeCrmDemo));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};